import { render, staticRenderFns } from "./catalog_tabs.vue.js?vue&type=template&id=683bd5a6&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./catalog_tabs.vue?vue&type=template&id=683bd5a6&vue3"
import script from "./catalog_tabs.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./catalog_tabs.vue?vue&type=script&lang=js&vue3"
export * from "./catalog_tabs.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./catalog_tabs.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports